import { FilterProps, Filter } from './';
import { FilterHeader } from '../filterHeader';
import { FacetFilter } from 'models/FacetFilter';
import { getActiveChoices } from 'components/Filter/utils';

interface FilterGroupProps extends FilterProps {
  facets: FacetFilter[];
  currencySymbol: string;
}

export const FilterGroup = ({
  displayName,
  facets,
  isOpen,
  toggleOpen,
  webCatalog,
  currencySymbol
}: FilterGroupProps) => (
  <div>
    <FilterHeader onClick={toggleOpen} displayName={displayName} border={!isOpen}>
      {getActiveChoices({ filterPanels: facets, currencySymbol })
        .map((facet: FacetFilter) => facet.displayName)
        .join(', ')}
    </FilterHeader>
    {isOpen && facets && (
      <div>
        {facets.map(f => (
          <Filter key={f.name} filter={f} webCatalog={webCatalog} noHeader forceOpen />
        ))}
      </div>
    )}
  </div>
);
